import { call, put, takeEvery } from "redux-saga/effects"

import { GET_TEACHERS, ADD_NEW_TEACHER, UPDATE_TEACHER, DELETE_TEACHER } from "./actionTypes";
import {
    getTeachersSuccess,
    getTeachersFail,
    addTeacherSuccess,
    addTeacherFail,
    updateTeacherSuccess,
    updateTeacherFail,
    deleteTeacherSuccess,
    deleteTeacherFail,
   
} from "./actions"

import {
    getTeachers,
    addNewTeacher,
    updateTeacher,
    deleteTeacher,
   
} from "helpers/teachers/teachers_backend_helper";
import { toast } from "react-toastify";

function* fetchTeachers() {
    try {
        const response = yield call(getTeachers)
        yield put(getTeachersSuccess(response))
    } catch (error) {
        yield put(getTeachersFail(error))
    }
}

function* onAddNewTeacher({ payload }) {
    try {

        
        const response = yield call(addNewTeacher, payload)

        console.log("RESPONSE:", response);
        yield put(addTeacherSuccess(response.teacher))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(addTeacherFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

/*
function* onUpdateTeacher({ payload: data }) {
    try {
        const response = yield call(updateTeacher, data)
        yield put(updateTeacherSuccess(response))
        toast.success("Branch  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updateTeacherFail(error))
        toast.error("Branch  Updated Failed", { autoClose: 2000 });
    }
}
    */

function* onUpdateTeacher({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateTeacher, payload)
        yield put(updateTeacherSuccess(response.teacher))
        toast.success(response.data.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateTeacherFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteTeacher({ payload: data }) {

    try {
        const response = yield call(deleteTeacher, data)
        yield put(deleteTeacherSuccess(response.teacherId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteTeacherFail(error))
        toast.error("Branch  Deleted Failed", { autoClose: 2000 });
    }
}


function* teacherSaga() {
    yield takeEvery(GET_TEACHERS, fetchTeachers)
    yield takeEvery(ADD_NEW_TEACHER, onAddNewTeacher)
    yield takeEvery(UPDATE_TEACHER, onUpdateTeacher)
    yield takeEvery(DELETE_TEACHER, onDeleteTeacher)
}

export default teacherSaga;